import { OccConfig, RoutingConfig } from '@spartacus/core'
import { EbOccFavoritesEndpoints } from './eb-occ-favorites-endpoints.modal'

export function ebFavoritesRoutingConfigFactory(): RoutingConfig {
  return {
    routing: {
      routes: {
        favorites: {
          paths: ['my-account/favorites/:shared/:listId', 'my-account/favorites/:shared'],
          paramsMapping: { listId: 'listId', shared: 'shared' }
        }
      }
    }
  }
}

const FAVORITES_URL = 'orgUsers/${userId}/favorites'
const ebFavoritesOccEndpoints: EbOccFavoritesEndpoints = {
  favoritesGetAll: FAVORITES_URL,
  favoritesGetAllForProduct: 'orgUsers/${userId}/favorites/product/${productCode}',
  favoritesGetSingle: 'orgUsers/${userId}/favorites/${listId}?fields=FULL',
  favoritesCreateForProduct: 'orgUsers/${userId}/favorites/create?productCode=${productCode}',
  favoritesCreate: 'orgUsers/${userId}/favorites/create',
  favoritesRemove: 'orgUsers/${userId}/favorites/remove/${listId}',
  favoritesRename: 'orgUsers/${userId}/favorites/update/${listId}?fields=FULL',
  favoritesShare: 'orgUsers/${userId}/favorites/update/${listId}/${isShared}?fields=FULL',
  favoritesComment: 'orgUsers/${userId}/favorites/update/comment?fields=FULL',
  favoritesEntriesRemoveSelected: 'orgUsers/${userId}/favorites/entries?fields=FULL',
  favoritesEntriesRemoveSingle: FAVORITES_URL,
  favoritesProductRemove: FAVORITES_URL,
  favoritesProductAdd: FAVORITES_URL
}

export function ebFavoritesConfigFactory(): OccConfig {
  return {
    backend: {
      occ: {
        endpoints: {
          ...ebFavoritesOccEndpoints
        },
        useWithCredentials: true
      }
    }
  }
}
